<template>
  <!-- 商品佣金设置 -->
  <div class="commissionSettings">
    <Setting class="Setting" />
    <!-- <SpecialSetting class="SpecialSetting" /> -->
  </div>
</template>

<script>
import Setting from './cmps/setting.vue'
import SpecialSetting from './cmps/specialSetting.vue'
export default {
  components: {
    // SpecialSetting,
    Setting
  },
  data () {
    return {}
  },
  mounted () {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.commissionSettings {
  .Setting {
    margin-bottom: 20px;
  }
  .SpecialSetting {
  }
}
</style>
